import * as yup from 'yup';
import { parsePhoneNumber } from 'awesome-phonenumber';

yup.addMethod<yup.StringSchema>(
  yup.string,
  'phoneNumber',
  // TODO: do not hardcode
  function (regionCode?: string, message = '${path} is not a valid phone number') {
    return this.test({
      exclusive: true,
      message,
      name: 'phoneNumber',
      test: (value?: string) => !value || parsePhoneNumber(value, { regionCode }).valid,
    });
  },
);

export default yup;
